import { useState, useEffect } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import "./Loading.css";

const TextAnimation = () => {
  const texts = [
    "Analyzing your resume",
    "Scanning for keywords",
    "Checking for experience",
    "Evaluating your skills",
    "Calculating your score",
    "Almost there",
  ];

  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentTextIndex < texts.length - 1) {
        setCurrentTextIndex((prevIndex) => prevIndex + 1);
      }
    }, 3000); // Adjust to control the delay between each text change

    return () => clearInterval(interval);
  }, [currentTextIndex]);

  return (
    <div className="flex gap-4">
      <div className="animate-text-appear rounded-full bg-green-500 p-1 delay-500">
        <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} />
      </div>
      <div
        className="animate-text-appear font-montserrat font-medium"
        key={currentTextIndex}
      >
        {texts[currentTextIndex]}
      </div>
    </div>
  );
};

export default TextAnimation;
